<template>
    <div class="help-container">
      <h2 class="help-title">Ayuda para la Gestión de Detalles Personales</h2>
      <p class="help-introduction">Este módulo facilita la administración integral de información personal, incluyendo datos básicos, médicos, citas y más. A continuación, se detallan las acciones disponibles:</p>
      <ul class="help-list">
        <li><strong>Buscar por Número, Cédula o Nombre:</strong> Ingresa el número de documento, cédula o nombre en los campos correspondientes para buscar registros específicos.</li>
        <li><strong>Generar CSV:</strong> Puedes generar un archivo CSV de los datos visibles haciendo clic en el botón "Generar CSV".</li>
        <li><strong>Ver Todos los Registros:</strong> Utiliza el botón "Todos los registros" para visualizar todos los datos disponibles sin filtros.</li>
        <li><strong>Agregar Nuevo Registro:</strong> Clic en "Nuevo registro" abre un formulario para ingresar nuevos datos de una persona.</li>
        <li><strong>Editar Información:</strong> Selecciona "Editar" desde el menú de acciones para modificar los datos de una persona específica.</li>
        <li><strong>Navegar por Secciones:</strong> Utiliza las pestañas para navegar entre diferentes secciones como medios de comunicación, registro médico, citas, atenciones, bitácora y seguros asociados a la persona.</li>
        <li><strong>Gestión de Citas y Atenciones Médicas:</strong> Administra citas y revisa atenciones médicas previas desde las pestañas correspondientes.</li>
        <li><strong>Visualización de Seguros:</strong> Accede y gestiona información relacionada con seguros de salud directamente desde su pestaña.</li>
      </ul>
      <p class="help-conclusion">Es crucial mantener la información actualizada y precisa para garantizar una gestión eficaz. Asegúrate de revisar y actualizar los datos regularmente.</p>
    </div>
  </template>
  
  <script>
  export default {
    name: "AyudaDetallesPersonales",
  };
  </script>
  
  <style src="@/assets/css/ayuda.css" scoped></style>
